import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete.component';
import { FormsModule } from '@angular/forms';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { ToggleDropdownModule } from '@fi-shared/fi-directives/toggle-dropdown';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        ToggleDropdownModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
    ],
    declarations: [AutocompleteComponent],
    exports: [AutocompleteComponent],
})
export class AutocompleteModule {}
